<template lang="pug">
div
  //- Title
  .d-flex.justify-space-between
    div.d-flex.align-center
      v-icon.mr-3(size="18") $yzi-activity-heart
      .text-md.font-semibold {{ $t('services') }}
    v-hover(v-slot="{ hover }")
      .text-sm.font-semibold.underline.clickable.px-3.py-1.round-lg(:class="[{ 'neutral300':hover }]" @click="onEdit") {{ $t('edit') }}
  v-divider.mt-2.mb-4.neutral500
  //- Content
  medication-table(:parentMedications="services" hideActions)
</template>

<script>
import MedicationTable from '@/components/clinic/checkout/MedicationTable.vue'

export default {
  components: {
    MedicationTable,
  },
  props: {
    services: {
      type: Array,
      default: () => {
        return []
      }
    },
    leadPid: {
      type: String,
      required: true
    },
    patientId: {
      type: Number,
      required: true
    },
    page: {
      type: Number,
      default: null
    },
    source: {
      type: String,
      default: 'patient-profile'
    }
  },
  methods: {
    onEdit () {
      if (this.source === 'patient-history') {
        // this.$router.push(`/admin/clinic/invoice/${this.leadPid}?origin=patient-history&page=${this.page}&leadPid=${this.leadPid}`)
        let params = { pid: this.leadPid, origin: 'ClinicConsultationDetails', data: { params: { pid: this.leadPid, savePage: this.page, viewAllHistory: true } } }
        if (this.$route.params && this.$route.params.origin && this.$route.params.data) {
          params.data.params.route = { name: this.$route.params.origin, ...this.$route.params.data }
        }
        this.$router.push({ name: 'ClinicInvoice', params })
      } else {
        // this.$router.push(`/admin/clinic/invoice/${this.leadPid}?origin=patient-profile&patientId=${this.patientId}&leadPid=${this.leadPid}`)
        let params = { pid: this.leadPid, origin: 'ClinicPatientDetails', data: { params: { id: this.patientId }, query: { leadPid: this.leadPid, tab: 'visits' } } }
        this.$router.push({ name: 'ClinicInvoice', params })
      }
    }
  },
}
</script>

<style lang="scss" scoped>
</style>